import {useCallback, useState} from 'react'

import { useAPI } from '../hoc/useAPI';


export const useGetPrices=()=>{
 const ENDPOINTS = useAPI()

    const [pricesData,setData]=useState<any[]>([])
    const [pricesDataLoading,setIsLoading]=useState(false)
    const [pricesError,setError]=useState('')
    const [pricesByGlassLoading,setIspricesByGlassLoading]=useState(false)
    const [pricesByGlassworkLoading,setIspricesByGlassworkLoading]=useState(false)
    const [pricesByGlassData,setPricesByGlassData]=useState<any[]>([])
    const [pricesByGlassworkData,setPricesByGlassworkData]=useState<any[]>([])
    const [pricesByGlassError,setPricesByGlassError]=useState('')
    const [pricesByGlassworkError,setPricesByGlassworkError]=useState('')

const getPrices=useCallback((page:number)=>{
    setIsLoading(true)
ENDPOINTS.pricing()
        .index({page,page_size:1000})
        .then((res:any)=>{
           
            if (res.data && res.data.data && res.data.data.pricing) {
                setData (res.data.data.pricing)
                setIsLoading(false)
            }
            else {
                setData([])
                setIsLoading(false)
            }
        })
        .catch((err:any)=>{
            setIsLoading(false)
            setError(err)
        })
  
},[ENDPOINTS])

const getPricesByGlasse=useCallback((glass_id:number)=>{
    setIspricesByGlassLoading(true)
ENDPOINTS.pricing()
        .selectByGlasses({glass_id,page:1,page_size:100,sort_field:35,sort_direction:'ASC'})
        .then((res:any)=>{
           
            if (res.data && res.data.data ) {
                setPricesByGlassData (res.data.data)
                setIspricesByGlassLoading(false)
            }
            else {
                setPricesByGlassData([])
                setIspricesByGlassLoading(false)
            }
        })
        .catch((err:any)=>{
            setIspricesByGlassLoading(false)
            setPricesByGlassError(err)
        })
  
},[ENDPOINTS])

const getPricesByGlassework=useCallback((glass_work_id:number)=>{
    setIspricesByGlassworkLoading(true)
ENDPOINTS.pricing()
        .selectByGlassWorks({glass_work_id})
        .then((res:any)=>{
           
            if (res.data && res.data.data ) {
                setPricesByGlassworkData (res.data.data)
                setIspricesByGlassworkLoading(false)
            }
            else {
                setPricesByGlassworkData([])
                setIspricesByGlassworkLoading(false)
            }
        })
        .catch((err:any)=>{
            setIspricesByGlassworkLoading(false)
            setPricesByGlassworkError(err)
        })
  
},[ENDPOINTS])
    return {getPrices,pricesData,pricesDataLoading,pricesError
        ,getPricesByGlasse,getPricesByGlassework
        ,pricesByGlassData,pricesByGlassError,pricesByGlassLoading,
        pricesByGlassworkData,pricesByGlassworkError,pricesByGlassworkLoading
    }
}